var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01822 0H7.98178C3.57357 0 0 3.57357 0 7.98178V8.01822C0 12.4264 3.57357 16 7.98178 16H8.01822C12.4264 16 16 12.4264 16 8.01822V7.98178C16 3.57357 12.4264 0 8.01822 0Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4757 3.25525H5.5249C4.15714 3.25525 3.04443 4.36796 3.04443 5.73572V10.265C3.04443 11.6328 4.15714 12.7455 5.5249 12.7455H10.4757C11.8435 12.7455 12.9562 11.6328 12.9562 10.265V5.73572C12.9562 4.36796 11.8435 3.25525 10.4757 3.25525ZM3.91947 5.73572C3.91947 4.8506 4.63978 4.13028 5.5249 4.13028H10.4757C11.3609 4.13028 12.0812 4.8506 12.0812 5.73572V10.265C12.0812 11.1501 11.3609 11.8705 10.4757 11.8705H5.5249C4.63978 11.8705 3.91947 11.1501 3.91947 10.265V5.73572Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00013 10.3073C9.27203 10.3073 10.3074 9.27247 10.3074 8C10.3074 6.72754 9.27259 5.69275 8.00013 5.69275C6.72766 5.69275 5.69287 6.72754 5.69287 8C5.69287 9.27247 6.72766 10.3073 8.00013 10.3073ZM8.00013 6.56834C8.78995 6.56834 9.43235 7.21074 9.43235 8.00056C9.43235 8.79039 8.78995 9.43279 8.00013 9.43279C7.2103 9.43279 6.5679 8.79039 6.5679 8.00056C6.5679 7.21074 7.2103 6.56834 8.00013 6.56834Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5214 6.06626C10.8638 6.06626 11.1429 5.78766 11.1429 5.4446C11.1429 5.10154 10.8643 4.82294 10.5214 4.82294C10.1784 4.82294 9.8999 5.10154 9.8999 5.4446C9.8999 5.78766 10.1784 6.06626 10.5214 6.06626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFInstagram);
export default __webpack_public_path__ + "static/media/f-instagram.3a5e1255489f637227c001911be917e4.svg";
export { ForwardRef as ReactComponent };